// extracted by mini-css-extract-plugin
module.exports = {"password":"styles_password__3DyxF","subtitle":"styles_subtitle__2DwTZ"};